import { render, staticRenderFns } from "./GamanzaTournaments.vue?vue&type=template&id=72f95fc0&scoped=true"
import script from "./GamanzaTournaments.vue?vue&type=script&lang=js"
export * from "./GamanzaTournaments.vue?vue&type=script&lang=js"
import style0 from "./GamanzaTournaments.vue?vue&type=style&index=0&id=72f95fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f95fc0",
  null
  
)

export default component.exports